module.exports = __webpack_public_path__ + "img/15df7a0abc50e61e5e918fa92afd98a0.png";